import { mapState } from "vuex";
import config from '@/app/editor/config';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { ENABLED_BACK_TO_EMBED_DASHBOARD } from '@/constants/feature-flag-key';
import { getEmbedAppUrl } from '@/utils/getEmbedAppUrl';

export default {
  computed: {
    ...mapState("app", {
      shopInfo: state => state.shopInfo,
    }),
    embedAppUrl() {
      return getEmbedAppUrl(this.shopInfo?.shopifyDomain);
    },
    pricingUrl() {
      const params = new URLSearchParams({
        from: 'editor-v6',
      });
      return `${this.embedAppUrl}/pricing?${params}`
    },
  },
  methods: {
    goToPricing() {
      window.open(this.pricingUrl, '_blank');
    }
  }
};
